import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessCalendar } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { CalendarOverviewPage } from "./pages/calendar-overview/CalendarOverviewPage";
import { ReservationDetailsPage } from "./pages/reservation-details/ReservationDetailsPage";
import { calendarRoutes } from "./routes";

export const calendarRoute = [
  {
    path: calendarRoutes.list,
    element: (
      <RequireAuth permission={canAccessCalendar}>
        <CalendarOverviewPage />
      </RequireAuth>
    ),
  },
  {
    path: calendarRoutes.reservationDetails,
    element: <ReservationDetailsPage />,
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
